import * as React from 'react';

import {
    F, Select, TabPanel, TabView, TogglePanel, useForm, InputSwitch, useLoading, useObjectState, useRemoteData, useTranslation
} from '@components';
import { IWork, IWorkSettings } from '@models';

export interface IProps {
    saveWork : Function;
    work : IWork;
}

const defaultSettings: IWorkSettings = {}

export default function AdminDocumentVisorConfiguration(props : IProps) {
    const { t } = useTranslation();
    const loading = useLoading();

    const workSettings = props.work.settingsObj ?? defaultSettings;

    const doSave = loading.wrap(async (..._: any) => {
        const w = {
            ...form.values,
            settings: form.get('settings'),
        };
        w.settings['acceptSubContractorRequests'] = form.get('__acceptSubContractorRequests');
        w.settings['mainContractorCanFulfillSubs'] = form.get('__mainContractorCanFulfillSubs');
        w.settings['rememberSubContractorAcceptances'] = form.get('__rememberSubContractorAcceptances');
        w.settings['documentVisorShowDocumentProperties'] = form.get('__documentVisorShowDocumentProperties');
        w.settings['showExpirationDateOnUpload'] = form.get('__showExpirationDateOnUpload');

        w.settings = JSON.stringify(w.settings);
        delete w['__acceptSubContractorRequests'];
        delete w['__mainContractorCanFulfillSubs'];
        delete w['__rememberSubContractorAcceptances'];
        delete w['__documentVisorShowDocumentProperties'];
        delete w['__showExpirationDateOnUpload'];

        await props.saveWork(w);
    });

    const form = useForm({
        initialValues: {
            id: props.work.id,
            name: props.work.name,
            countryId: props.work.countryId,
            settings: workSettings,
            contextData: props.work.contextData,
            __acceptSubContractorRequests: workSettings?.acceptSubContractorRequests,
            __mainContractorCanFulfillSubs: workSettings?.mainContractorCanFulfillSubs,
            __rememberSubContractorAcceptances: workSettings?.rememberSubContractorAcceptances,
            __documentVisorShowDocumentProperties: workSettings?.documentVisorShowDocumentProperties,
            __showExpirationDateOnUpload: workSettings?.showExpirationDateOnUpload,
        }
    });

    return (
        <div className='c h100p'>
            <div className={'center g20 w100'}
                style={{ marginTop: '40px', display: 'grid', gridTemplateColumns: '60% auto', gridGap: '20px' }}>
                    <label className={'text-right'}>{t('Show document properties')}</label>
                    {form.checkBox('__documentVisorShowDocumentProperties')}
            </div>
            <div className='e' />
            <div className='r'>
                <div className='e' />
                {loading.render()}
                <button
                    className='primary'
                    disabled={loading.isLoading()}
                    onClick={doSave}>
                    {t('Save')}
                </button>
            </div>
        </div>
    );
}


